import { connect } from 'react-redux';
import {
    actions
} from '../../../../../redux/modules/Paciente/paciente';
import PacienteGrid from './PacienteGrid';

const mstp = state => {
    return {...state.paciente}
};

const mdtp = {
    ...actions
};

export default connect(mstp, mdtp)(PacienteGrid)
